<template>
  <div class="switch">
    <ul class="buttons">
      <li class="active border button1">
        <div class="inner"><p class="tab">すべて</p></div>
      </li>
      <li class="premium button1" @click="tapPremium()">
        <div class="inner">
          <img src="~@/assets/img/coupon/icon_premium.svg" />
        </div>
        <div class="inner"><p class="tab">プレミアム</p></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'NewsTab',
  data: function() {
    return {
      optionFreepass: 'フリーパス',
      optionCoupon: 'クーポン',
      optionPremium: 'プレミアム',
      isSelect: 'クーポン'
    }
  },
  async created() {
    this.isSelect = this.select
  },
  methods: {
    changeList: function(isSelect) {
      this.isSelect = isSelect
      this.$emit('click', isSelect)
    },
    tapPremium: function() {
      this.$emit('click', this.optionPremium)
    }
  }
}
</script>

<style scoped lang="scss">
.border {
  border-left: 1px solid #592711;
  border-right: 1px solid #592711;
}
.switch {
  display: block;
  text-align: center;
  padding: 10px 0;

  .buttons {
    width: 100%;
    margin: 0 auto;
    overflow: hidden;
    border: 1px solid #592711;
    background-color: white;
    border-radius: 5px;
    color: #592711;
    font-size: 12px;
    font-weight: bold;

    .button1 {
      display: inline-block;
      width: 50%;
      text-align: center;
      padding: 2px 0;
    }
    .button2 {
      display: inline-block;
      height: 100%;
      width: 33.3%;
      text-align: center;
      padding: 6px 0;
    }
    .active {
      background-color: #592711;
      color: white;
    }
    .tab {
      display: inline-block;
      margin-left: 1px;
      margin-top: 4.7px;
      padding-bottom: 5.3px;
    }
    .inner {
      display: inline-block;
      vertical-align: middle;
    }
  }
}
</style>
